import { getRequest, postRequest } from "../../shared/api/axiosHandler";

export const getCategories = async () => {
  try {
    return await getRequest('/public/category');
  } catch (error) {
    throw error;
  }
};

export const getSubCategories = async (id) => {
  try {
    return await getRequest(`/public/category/sub?id=${id}`);
  } catch (error) {
    throw error;
  }
}

export const searchProductsWithKeywords = async (query, page = 0, size = 10) => {
  try {
    return await getRequest(`/public/api/searched-keywords/products?keyword=${query}&page=${page}&size=${size}`);
  } catch (error) {
    throw error;
  }
};

export const getSearchedKeywords = async (keyword) => {
  try {
    return await getRequest(`/public/api/searched-keywords?name=${keyword}`);
  } catch (error) {
    throw error;
  }
};

export const getProductsByCategory = async (id, page = 0, size = 20) => {
    try {
        return await getRequest(`/public/products/category/${id}?page=${page}&size=${size}`);
    } catch (error) {
        throw error;
    }
    }

export const getProductBySlug = async (slug) => {
      try {
          return await getRequest(`/public/products/slug/${slug}`);
      } catch (error) {
          throw error;
      }
      }

export const getBreadcrumbByProductId = async (productId) => {
      try {
        return await getRequest(`/public/products/breadcrumb/${productId}`);
      } catch (error) {
        throw error;
      }
}

export const getPriceRange = async () => {
  try {
    return await getRequest('/public/products/priceRange');
  } catch (error) {
    throw error;
  }
}

export const fetchFilteredProducts = async (
  page = 0, 
  size = 18, 
  minPrice, 
  maxPrice, 
  categoryIds = [], // Accept array of category IDs
  sortOption = "newArrivals"  // Default sort option
) => {
  try {
    let url = `/public/products/filter?page=${page}&size=${size}&minPrice=${minPrice}&maxPrice=${maxPrice}&sortOption=${sortOption}`;

    if (categoryIds.length > 0) {
      const categoryQuery = categoryIds.map(id => `productCategoryIds=${id}`).join("&");
      url += `&${categoryQuery}`;
    }

    return await getRequest(url);
  } catch (error) {
    throw error;
  }
};

export const getProductsByListOfIds = async (ids) => {
  try {
    return await postRequest(`/public/products/list`, ids);
  } catch (error) {
    throw error;
  }
}

export const fetchProductsByCategories = async (categoryIds, page = 0, size = 30) => {
  try {
    const ids = categoryIds.join(",");
    const response = await getRequest(`/public/products/category?productCategoryIds=${ids}&page=${page}&size=${size}`);
    return response;
  } catch (error) {
    throw error;
  }
};
